import { ClockIcon, HeartIcon, TrophyIcon, UserGroupIcon } from '@heroicons/react/24/outline';

const About = () => {
  const features = [
    {
      icon: HeartIcon,
      title: "Experiencia Comprobada",
      description: "Más de 20 años especializados en cardiología con miles de pacientes satisfechos.",
      stat: "20+",
      label: "Años"
    },
    {
      icon: UserGroupIcon,
      title: "Equipo Especializado",
      description: "Cardiólogos certificados y personal médico altamente capacitado para tu cuidado.",
      stat: "10+",
      label: "Especialistas"
    },
    {
      icon: TrophyIcon,
      title: "Tecnología Avanzada",
      description: "Equipos de última generación para diagnósticos precisos y tratamientos efectivos.",
      stat: "100%",
      label: "Precisión"
    },
    {
      icon: ClockIcon,
      title: "Atención Integral",
      description: "Horario corrido de 8:00 a 20:00 horas de lunes a viernes y sábados de 8:00 a 14:00 horas.",
      stat: "Lun-Sáb",
      label: "Horarios"
    }
  ];

  return (
    <section id="nosotros" className="py-12 sm:py-16 lg:py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12 sm:mb-16 lg:mb-20">
              <div className="inline-flex items-center px-3 sm:px-4 py-2 bg-primary/10 text-primary text-xs sm:text-sm font-semibold rounded-full mb-6 sm:mb-8">
                <HeartIcon className="h-3 w-3 sm:h-4 sm:w-4 mr-2 text-primary" />
                Sobre Nosotros
              </div>
<h1
  className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-anaktoria font-light italic tracking-wide leading-tight mb-4 sm:mb-6 lg:mb-8 !text-marino [&_span]:text-accent-400 px-4 sm:px-0"
>
  "Tu <span className="font-semibold drop-shadow-sm">corazón</span> es primero"
</h1>


              <p className="text-base sm:text-lg lg:text-xl text-text-secondary max-w-3xl mx-auto leading-relaxed font-sans px-4 sm:px-0 text-justify">
                En Cardiología del Norte, nos dedicamos a brindar un cuidado integral para la salud de tu corazón. Ofrecemos evaluaciones preventivas para identificar riesgos y diagnósticos avanzados con tecnología de punta. Nuestros tratamientos personalizados están diseñados para adaptarse a tus necesidades específicas. En Cardiología del Norte, tu salud cardíaca es nuestra prioridad.
              </p>
              </div>

              {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center mb-16 sm:mb-20 lg:mb-24">
          {/* Left Column - Image Grid (Mobile: stack, Desktop: side by side) */}
          <div className="relative order-2 lg:order-1">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div className="space-y-3 sm:space-y-4">
                <img
                  src="/cardio_01.jpeg"
                  alt="Cardiología Moderna"
                  className="w-full h-48 sm:h-56 lg:h-64 object-cover rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                />
                <img
                  src="/cardio_03.jpg"
                  alt="Tecnología Médica"
                  className="w-full h-36 sm:h-40 lg:h-48 object-cover rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                />
              </div>
              <div className="space-y-3 sm:space-y-4 sm:pt-6 lg:pt-8">
                <img
                  src="/cardio_02.jpeg"
                  alt="Atención Personalizada"
                  className="w-full h-36 sm:h-40 lg:h-48 object-cover rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                />
                <img
                  src="/cardio_04.jpg"
                  alt="Especialistas"
                  className="w-full h-48 sm:h-56 lg:h-64 object-cover rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                />
              </div>
            </div>

            <div className="absolute -bottom-4 sm:-bottom-6 -right-4 sm:-right-6 bg-surface p-4 sm:p-6 rounded-xl sm:rounded-2xl shadow-card-hover">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl font-bold text-primary">98%</div>
                <div className="text-xs sm:text-sm text-text-secondary">Satisfacción</div>
              </div>
            </div>
            </div>
            <div className="space-y-6 sm:space-y-8 order-1 lg:order-2">
              <div>
                <h3 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-primary font-serif mb-4 sm:mb-6">
                  Líderes en Cardiología en el Norte de México
                </h3>
                <div className="space-y-3 sm:space-y-4 text-text-secondary leading-relaxed font-sans text-sm sm:text-base">
                  <p className="text-justify">
                    Con más de dos décadas de experiencia, nos hemos consolidado como el
                    centro de referencia cardiovascular más confiable de la región,
                    ofreciendo diagnósticos precisos y tratamientos de vanguardia.
                  </p>
                  <p className="text-justify">
                    Nuestro equipo multidisciplinario de especialistas certificados
                    trabaja con tecnología de última generación para brindarte
                    atención médica de clase mundial sin salir de tu ciudad.
                  </p>
                  <p className="text-justify">
                    Creemos en la prevención como la mejor medicina, por eso ofrecemos
                    programas integrales de salud cardiovascular adaptados a las
                    necesidades específicas de cada paciente.
                  </p>
                </div>
              </div>

{/* CTA Buttons Modernizados */}
<div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-4">
  {/* Botón Primario */}
  <a
    href="#servicios"
    className="
      inline-flex items-center justify-center
      px-6 sm:px-8 py-3 sm:py-4
      bg-gradient-to-r from-primary to-primary/80
      text-white font-semibold font-sans
      text-sm sm:text-base
      rounded-xl shadow-md
      transition-all duration-300
      hover:scale-[1.04] hover:shadow-xl
      hover:from-primary-500 hover:to-primary-700
      focus:outline-none focus:ring-2 focus:ring-primary/40
    "
  >
    Ver Servicios
  </a>

  {/* Botón Secundario */}
  <a
  href="#doctores"
  className="
    inline-flex items-center justify-center
    px-6 sm:px-8 py-3 sm:py-4
    border-2 border-primary bg-white
    text-primary font-semibold font-sans
    text-sm sm:text-base
    rounded-xl transition-all duration-300
    hover:scale-[1.04]
    hover:border-primary-500 hover:bg-primary-50 hover:text-primary-900
    shadow-sm hover:shadow-md
    focus:outline-none focus:ring-2 focus:ring-primary/30
  "
>
  Conoce al Equipo
</a>
</div>



          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-surface p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-card hover:shadow-card-hover transition-all duration-300 hover:-translate-y-2 text-center border border-border"
            >
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-primary/10 group-hover:bg-primary rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 transition-colors duration-300">
                <feature.icon className="h-6 w-6 sm:h-8 sm:w-8 text-primary group-hover:text-text-inverse transition-colors duration-300" />
              </div>

              <div className="mb-3 sm:mb-4">
                <div className="text-2xl sm:text-3xl font-bold text-primary mb-1 font-serif">{feature.stat}</div>
                <div className="text-xs sm:text-sm text-text-secondary font-medium font-sans">{feature.label}</div>
              </div>

              <h4 className="text-lg sm:text-xl font-bold text-primary mb-2 sm:mb-3 font-serif">
                {feature.title}
              </h4>
              <p className="text-sm sm:text-base text-text-secondary leading-relaxed font-sans">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
